import { api } from "../api/callApi";
import { urlFactory } from "../api/v1";
import { IFactory } from "../varibles/interface";

export const factoryService = {
    create: (body: IFactory) => api.post<IFactory>(urlFactory, body),
    update: (body: IFactory) => api.put<IFactory>(urlFactory, body),
    gets: () => api.get<IFactory[]>(urlFactory),
    getByAdmin: () => api.get<IFactory[]>(urlFactory + '/s'),
}